export function initProgram(){
    const list = document.querySelector(".list-program") as HTMLUListElement | null;
    const button = document.querySelector(
        ".list-program-container .button"
    ) as HTMLButtonElement | null;

    if (!list || !button) return;

    const items = Array.from(list.querySelectorAll("li"));

    if (items.length > 3) {
        // скрываем все, начиная с 4-го
        items.forEach((li, index) => {
            if (index > 2) li.classList.add("hidden");
        });

        button.classList.add("button-show-all");
        button.style.display = "flex";

        button.addEventListener("click", () => {
            items.forEach((li) => li.classList.remove("hidden"));
            button.style.display = "none";
        });
    }
}